import EleGallery from './EleGallery'

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.component('ele-gallery', EleGallery)
}

export default EleGallery
